module.exports = __webpack_public_path__ + "static/media/QASandboxLogo.bb8b6e71.png";